import { service } from '@ember/service';
import Component from '@glimmer/component';

import { t } from 'ember-intl';
import momentFormat from 'ember-moment/helpers/moment-format';
import { and, not } from 'ember-truth-helpers';

import { getBem } from 'umg-ember-backend/utils/get-bem';

import Primary from './primary';
import Secondary from './secondary';
import styles from './styles.module.css';
import Variants from './variants';

const bem = getBem(styles);

export default class RecordDetailToolbarComponent extends Component {
  @service recordLocks;
  @service recordRelationships;
  @service recordStatus;

  get isLocked() {
    return this.recordLocks.isLocked(this.args.model);
  }

  get hasDirtyModelFields() {
    return this.recordRelationships.hasDirtyFields(this.args.model);
  }

  get isBlocked() {
    return this.recordStatus.isBlocked(this.args.model);
  }

  <template>
    <div class={{(bem)}} ...attributes>
      <div class={{bem 'variants'}}>
        <Variants @model={{@model}} />
      </div>

      <div class={{bem 'primary'}}>
        {{#if (has-block 'additonalPrimaryActions')}}
          {{yield to='additonalPrimaryActions'}}
        {{/if}}
        <Primary @model={{@model}} @actions={{@primaryActions}} />
      </div>

      <div class={{bem 'secondary'}}>
        {{#if @secondaryActions}}
          <Secondary @model={{@model}} @actions={{@secondaryActions}} />
        {{/if}}
      </div>

      {{#if (and this.isBlocked (not this.hasDirtyModelFields))}}
        <div class={{bem 'locked-message'}}>
          {{t 'record_detail.toolbar.blocked_message'}}
        </div>
      {{/if}}

      {{#if this.isLocked}}
        <div class={{bem 'locked-message'}}>
          {{t
            'record_detail.toolbar.locked_message'
            locker=@model.cmsLockerId.name
            lockTime=(momentFormat @model.cmsLocktime 'L LT')
          }}
        </div>
      {{/if}}
    </div>
  </template>
}
